import React from 'react';
import {Redirect } from 'react-router-dom';

class Home extends React.Component {


    render() {
        return (
            <div>
                <h1>Home</h1>
            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home.js